
















import { Component, Watch, Vue } from 'vue-property-decorator';
import AppBar from './components/app-bar.vue';
import NavigationDrawer from './components/navigation-drawer.vue';
import { Route } from 'vue-router';
import { CollectionNamesPlusArr } from './services/meiosis';
import { IScenario } from './models';

@Component({
  components: {
    AppBar,
    NavigationDrawer,
  },
})
export default class App extends Vue {
  private theme = '';
  private scenarios?: Partial<IScenario>[] = [];
  private activeScenario?: Partial<IScenario> = {};
  private note = '';
  private snackbar = false;

  constructor() {
    super();
    console.log(CollectionNamesPlusArr);
    CollectionNamesPlusArr.forEach(async n => {
      // eslint-disable-next-line no-prototype-builtins
      if (this.$store.actions.hasOwnProperty(n)) this.$store.actions[n].updateList();
    });
  }

  @Watch('scenarios')
  private scenariosUpdated() {
    if (!this.activeScenario && this.scenarios && this.scenarios.length > 0) {
      this.$store.actions['scenarios'].load(this.scenarios[0].id || '');
    }
  }

  @Watch('activeScenario')
  private activeScenarioUpdated() {
    if (this.activeScenario && this.activeScenario.id) {
      if (!this.$store.states().app.narrative || !this.$store.states().app.narrative.id) {
        if (this.activeScenario.narratives && this.activeScenario.narratives.length > 0) {
          this.$store.actions.changeNarrative(this.activeScenario.narratives[0]);
        }
      }
    }
  }

  @Watch('snackbar')
  snackbarUpdated(active: boolean): void {
    if (!active) {
      this.$store.actions.notify('');
    }
  }

  @Watch('note')
  noteUpdated(note: string): void {
    if (note && note != '') {
      this.snackbar = true;
    }
  }

  @Watch('theme')
  themeUpdated(theme: string): void {
    this.$vuetify.theme.dark = theme === 'dark' ? true : false;
  }

  @Watch('$route')
  routeUpdated(to: Route): void {
    if (`/${this.$store.states().app.route}` !== to.path) {
      this.$store.actions.changePage(to.path);
    }
  }

  public mounted(): void {
    this.$store.states.map(s => {
      this.theme = s.app.theme;
      this.note = s.app.note;
      this.scenarios = s.scenarios.list;
      this.activeScenario = s.scenarios.current;
    });
  }
}
